/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  UserSolutionApplicationListResponse,
  UtxSolutionApplicationGetUserApplicationsParams,
  UserStartSolutionApplicationResponse,
  UserStartSolutionApplicationBody,
  UserGetSolutionApplicationStateResponse,
  UserUpdateSolutionApplicationStateResponse,
  UserUpdateSolutionApplicationStateBody
} from './schema'



export const utxSolutionApplicationGetUserApplications = (
    params?: UtxSolutionApplicationGetUserApplicationsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.get(
      `/solution-applications`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxSolutionApplicationGetUserApplicationsQueryKey = (params?: UtxSolutionApplicationGetUserApplicationsParams,) => [`/solution-applications`, ...(params ? [params]: [])];

    
export type UtxSolutionApplicationGetUserApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof utxSolutionApplicationGetUserApplications>>>
export type UtxSolutionApplicationGetUserApplicationsQueryError = AxiosError<UserSolutionApplicationListResponse>

export const useUtxSolutionApplicationGetUserApplications = <TData = Awaited<ReturnType<typeof utxSolutionApplicationGetUserApplications>>, TError = AxiosError<UserSolutionApplicationListResponse>>(
 params?: UtxSolutionApplicationGetUserApplicationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxSolutionApplicationGetUserApplications>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxSolutionApplicationGetUserApplicationsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxSolutionApplicationGetUserApplications>>> = ({ signal }) => utxSolutionApplicationGetUserApplications(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxSolutionApplicationGetUserApplications>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxSolutionApplicationStartSolutionApplication = (
    userStartSolutionApplicationBody: UserStartSolutionApplicationBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.post(
      `/solution-applications`,
      userStartSolutionApplicationBody,options
    );
  }



    export type UtxSolutionApplicationStartSolutionApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof utxSolutionApplicationStartSolutionApplication>>>
    export type UtxSolutionApplicationStartSolutionApplicationMutationBody = UserStartSolutionApplicationBody
    export type UtxSolutionApplicationStartSolutionApplicationMutationError = AxiosError<UserStartSolutionApplicationResponse>

    export const useUtxSolutionApplicationStartSolutionApplication = <TError = AxiosError<UserStartSolutionApplicationResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxSolutionApplicationStartSolutionApplication>>, TError,{data: UserStartSolutionApplicationBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxSolutionApplicationStartSolutionApplication>>, {data: UserStartSolutionApplicationBody}> = (props) => {
          const {data} = props ?? {};

          return  utxSolutionApplicationStartSolutionApplication(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxSolutionApplicationStartSolutionApplication>>, TError, {data: UserStartSolutionApplicationBody}, TContext>(mutationFn, mutationOptions)
    }
    export const utxSolutionApplicationGetSolutionApplicationState = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.get(
      `/solution-applications/${id}/state`,options
    );
  }


export const getUtxSolutionApplicationGetSolutionApplicationStateQueryKey = (id: string,) => [`/solution-applications/${id}/state`];

    
export type UtxSolutionApplicationGetSolutionApplicationStateQueryResult = NonNullable<Awaited<ReturnType<typeof utxSolutionApplicationGetSolutionApplicationState>>>
export type UtxSolutionApplicationGetSolutionApplicationStateQueryError = AxiosError<UserGetSolutionApplicationStateResponse>

export const useUtxSolutionApplicationGetSolutionApplicationState = <TData = Awaited<ReturnType<typeof utxSolutionApplicationGetSolutionApplicationState>>, TError = AxiosError<UserGetSolutionApplicationStateResponse>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxSolutionApplicationGetSolutionApplicationState>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxSolutionApplicationGetSolutionApplicationStateQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxSolutionApplicationGetSolutionApplicationState>>> = ({ signal }) => utxSolutionApplicationGetSolutionApplicationState(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxSolutionApplicationGetSolutionApplicationState>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxSolutionApplicationUpdateSolutionApplicationState = (
    id: string,
    userUpdateSolutionApplicationStateBody: UserUpdateSolutionApplicationStateBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.post(
      `/solution-applications/${id}/state`,
      userUpdateSolutionApplicationStateBody,options
    );
  }



    export type UtxSolutionApplicationUpdateSolutionApplicationStateMutationResult = NonNullable<Awaited<ReturnType<typeof utxSolutionApplicationUpdateSolutionApplicationState>>>
    export type UtxSolutionApplicationUpdateSolutionApplicationStateMutationBody = UserUpdateSolutionApplicationStateBody
    export type UtxSolutionApplicationUpdateSolutionApplicationStateMutationError = AxiosError<UserUpdateSolutionApplicationStateResponse>

    export const useUtxSolutionApplicationUpdateSolutionApplicationState = <TError = AxiosError<UserUpdateSolutionApplicationStateResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxSolutionApplicationUpdateSolutionApplicationState>>, TError,{id: string;data: UserUpdateSolutionApplicationStateBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxSolutionApplicationUpdateSolutionApplicationState>>, {id: string;data: UserUpdateSolutionApplicationStateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  utxSolutionApplicationUpdateSolutionApplicationState(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxSolutionApplicationUpdateSolutionApplicationState>>, TError, {id: string;data: UserUpdateSolutionApplicationStateBody}, TContext>(mutationFn, mutationOptions)
    }
    export const utxSolutionApplicationResetSolutionApplicationStatus = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.post(
      `/solution-applications/${id}/reset`,undefined,options
    );
  }



    export type UtxSolutionApplicationResetSolutionApplicationStatusMutationResult = NonNullable<Awaited<ReturnType<typeof utxSolutionApplicationResetSolutionApplicationStatus>>>
    
    export type UtxSolutionApplicationResetSolutionApplicationStatusMutationError = AxiosError<UserUpdateSolutionApplicationStateResponse>

    export const useUtxSolutionApplicationResetSolutionApplicationStatus = <TError = AxiosError<UserUpdateSolutionApplicationStateResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxSolutionApplicationResetSolutionApplicationStatus>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxSolutionApplicationResetSolutionApplicationStatus>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  utxSolutionApplicationResetSolutionApplicationStatus(id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxSolutionApplicationResetSolutionApplicationStatus>>, TError, {id: string}, TContext>(mutationFn, mutationOptions)
    }
    